import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const useFormSchema = (schema, rest) => {
  const formSchema = z.object(schema);

  const methods = useForm({
    resolver: zodResolver(formSchema),
    ...rest,
  });

  return methods;
};
